<template>
  <div></div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import wxApi from '@/api/wx'
export default {
  name: 'WxAuth',
  created () {
    this.init()
  },
  methods: {
    init () {
      const authCode = this.$route.query.code || ''
      const targetPath = this.$route.query.target

      console.log(targetPath)
      if (authCode) {
        // 请求参数中包括code参数，则认为是微信认证后跳回的页面
        wxApi.getAuthInfo(authCode).then(response => {
          if (response.data.resultCode === '0') {
            const wxUserInfo = {
              openId: response.data.resultData.openId || '',
              wxNickName: response.data.resultData.wxNickName || ''
            }
            sessionStorageUtils.set('wxUserInfo', wxUserInfo)
            if (targetPath) {
              console.log(targetPath)
              document.location.replace('/v2' + targetPath)
            } else {
              document.location = '/#/tab/home'
            }
          } else {
            this.$dialog.alert({ message: '微信授权失败' }).then(() => {
              this.$router.push({ name: 'home' })
            })
          }
        }).catch(() => {
          this.$dialog.alert({ message: '微信授权失败' }).then(() => {
            this.$router.push({ name: 'home' })
          })
        })
      } else {
        const curUrl = commonUtils.getCurrentUrl()
        const wxAuthUrl = commonUtils.getWxAuthUrl(curUrl, 'userInfo')
        document.location = wxAuthUrl
      }
    }
  }
}
</script>

<style>

</style>
